var _rect, _rect2, _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasking2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1210_1039",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 91
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1210_1039)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1210_1039",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 91,
    height: 91
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 91,
    height: 91,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1210_1039)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -46.4293,
    y1: 49.238,
    x2: 49.2379,
    y2: -46.4292,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -26.881,
    y1: 68.7863,
    x2: 68.7862,
    y2: -26.8809,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -36.6552,
    y1: 59.0117,
    x2: 59.012,
    y2: -36.6556,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -17.1068,
    y1: 78.5605,
    x2: 78.5604,
    y2: -17.1067,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -41.5423,
    y1: 54.1245,
    x2: 54.125,
    y2: -41.5428,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -25.2519,
    y1: 70.4155,
    x2: 70.4153,
    y2: -25.2518,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -31.7681,
    y1: 63.8989,
    x2: 63.8992,
    y2: -31.7684,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -12.2197,
    y1: 83.4477,
    x2: 83.4475,
    y2: -12.2195,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -44.8003,
    y1: 50.8667,
    x2: 50.8669,
    y2: -44.8006,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -23.623,
    y1: 72.0439,
    x2: 72.0443,
    y2: -23.6233,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -35.0261,
    y1: 60.6411,
    x2: 60.6411,
    y2: -35.0262,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -15.4777,
    y1: 80.1892,
    x2: 80.1895,
    y2: -15.4781,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39.9133,
    y1: 55.7539,
    x2: 55.754,
    y2: -39.9134,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -21.9939,
    y1: 73.6733,
    x2: 73.6734,
    y2: -21.9939,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -30.1391,
    y1: 65.5283,
    x2: 65.5282,
    y2: -30.139,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10.5907,
    y1: 85.0761,
    x2: 85.0766,
    y2: -10.5911,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -43.1713,
    y1: 52.4961,
    x2: 52.4959,
    y2: -43.1712,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -20.3649,
    y1: 75.3025,
    x2: 75.3024,
    y2: -20.3648,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -33.3971,
    y1: 62.2702,
    x2: 62.2701,
    y2: -33.397,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -13.8488,
    y1: 81.8186,
    x2: 81.8185,
    y2: -13.8487,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -38.2842,
    y1: 57.383,
    x2: 57.3831,
    y2: -38.2842,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -18.7358,
    y1: 76.9314,
    x2: 76.9314,
    y2: -18.7359,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -28.51,
    y1: 67.1567,
    x2: 67.1572,
    y2: -28.5105,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -8.96168,
    y1: 86.7055,
    x2: 86.7056,
    y2: -8.96171,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -7.33274,
    y1: 88.3347,
    x2: 88.3345,
    y2: -7.33256,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.2156,
    y1: 107.883,
    x2: 107.883,
    y2: 12.2158,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.44146,
    y1: 98.1088,
    x2: 98.1087,
    y2: 2.44161,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.9898,
    y1: 117.657,
    x2: 117.657,
    y2: 21.9899,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2.44562,
    y1: 93.2216,
    x2: 93.2216,
    y2: -2.4456,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13.8446,
    y1: 109.512,
    x2: 109.512,
    y2: 13.8449,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.32858,
    y1: 102.996,
    x2: 102.996,
    y2: 7.32857,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26.8769,
    y1: 122.545,
    x2: 122.544,
    y2: 26.8774,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.1579,
    y1: 130.826,
    x2: 130.825,
    y2: 35.1584,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5.70368,
    y1: 89.9636,
    x2: 89.9636,
    y2: -5.70366,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.4737,
    y1: 111.141,
    x2: 111.141,
    y2: 15.4738,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4.07043,
    y1: 99.738,
    x2: 99.7377,
    y2: 4.07076,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.6189,
    y1: 119.286,
    x2: 119.286,
    y2: 23.6189,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.8999,
    y1: 127.567,
    x2: 127.567,
    y2: 31.8999,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.816688,
    y1: 94.8508,
    x2: 94.8506,
    y2: -0.816451,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.1027,
    y1: 112.77,
    x2: 112.77,
    y2: 17.103,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.95751,
    y1: 104.625,
    x2: 104.625,
    y2: 8.95772,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.506,
    y1: 124.173,
    x2: 124.173,
    y2: 28.5061,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.787,
    y1: 132.454,
    x2: 132.454,
    y2: 36.7871,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.07474,
    y1: 91.5927,
    x2: 91.5925,
    y2: -4.07451,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.7317,
    y1: 114.399,
    x2: 114.399,
    y2: 18.7321,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.69946,
    y1: 101.367,
    x2: 101.367,
    y2: 5.69991,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.2479,
    y1: 120.915,
    x2: 120.915,
    y2: 25.2482,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.5289,
    y1: 129.196,
    x2: 129.196,
    y2: 33.5293,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.812371,
    y1: 96.4799,
    x2: 96.4796,
    y2: 0.8127,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.3608,
    y1: 116.028,
    x2: 116.028,
    y2: 20.3608,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.5866,
    y1: 106.254,
    x2: 106.254,
    y2: 10.5866,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.1349,
    y1: 125.803,
    x2: 125.802,
    y2: 30.1355,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.416,
    y1: 134.084,
    x2: 134.083,
    y2: 38.4165,
    stroke: "#FFB416"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.9632,
    y1: 135.63,
    x2: 135.63,
    y2: 39.9628,
    stroke: "#FFB416"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.4998 41.0553L84.4997 41.0553V41.0649V43.128C84.4997 43.7001 84.0292 44.1738 83.4539 44.1738H55.5459C54.9737 44.1738 54.5 43.7033 54.5 43.128V41.0649C54.5 40.4927 54.9705 40.019 55.5459 40.019H83.4649C84.0469 40.019 84.5108 40.4861 84.4998 41.0553Z",
    fill: "#29BE11",
    stroke: "#68E146"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7779 36.3986L68.7777 36.3983L58.1951 25.8322C58.1948 25.8319 58.1945 25.8316 58.1942 25.8313C57.7877 25.4201 57.7903 24.7514 58.1935 24.3482L59.6552 22.8865C59.6554 22.8862 59.6557 22.886 59.6559 22.8857C60.0671 22.4791 60.7359 22.4816 61.1392 22.8849C61.1392 22.8849 61.1392 22.8849 61.1392 22.8849L66.5799 28.3256L67.4335 29.1792V27.9721V7.54589C67.4335 6.96495 67.9017 6.5 68.4794 6.5H70.5424C71.1145 6.5 71.5882 6.97045 71.5882 7.54589V27.9666V29.1746L72.442 28.32L77.8738 22.8826C77.8744 22.882 77.8749 22.8815 77.8755 22.881C78.2934 22.4722 78.9573 22.4772 79.3595 22.8794L80.8196 24.3395C80.8201 24.34 80.8206 24.3405 80.8211 24.341C81.23 24.7591 81.225 25.423 80.8228 25.8251L80.8228 25.8251L70.2493 36.3986L70.2493 36.3986L70.2461 36.4019C70.0467 36.605 69.7808 36.7088 69.5136 36.7088C69.2538 36.7088 68.9854 36.6061 68.7779 36.3986Z",
    fill: "#29BE11",
    stroke: "#68E146"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7999 52H23.2027C20.3333 52 18 54.3326 18 57.2053V89.9213C18 92.7907 20.3333 95.1208 23.2027 95.1208H58.7998C61.6691 95.1208 64 92.7907 64 89.9213V57.2053C64.0002 54.3326 61.6693 52 58.7999 52ZM47.746 59.7413C50.5209 59.7413 52.7712 61.9918 52.7712 64.7665C52.7712 67.5412 50.5207 69.7917 47.746 69.7917C44.9704 69.7917 42.7209 67.5412 42.7209 64.7665C42.7209 61.9918 44.9704 59.7413 47.746 59.7413ZM57.1683 90.3115H40.9996H25.5513C24.1634 90.3115 23.5453 89.3074 24.171 88.0685L32.7951 70.9869C33.42 69.7482 34.6109 69.6377 35.4543 70.7398L44.1261 82.0725C44.9695 83.1747 46.4436 83.2685 47.4193 82.281L49.5407 80.1327C50.5156 79.1452 51.952 79.2675 52.7477 80.4041L58.2411 88.251C59.0352 89.3893 58.5561 90.3115 57.1683 90.3115Z",
    fill: "url(#paint0_linear_1210_1039)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-11.2679 40.75L11.6817 1L34.6314 40.75H-11.2679Z",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1210_1039",
    x1: 41,
    y1: 52,
    x2: 41,
    y2: 95.1208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6953D9",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6953D9",
    stopOpacity: 0.36
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasking2);
export default __webpack_public_path__ + "static/media/masking-2.5e693bbcc00e0a562445a6ed52e7235a.svg";
export { ForwardRef as ReactComponent };